module.exports = __webpack_public_path__ + "static/media/reminders.64fbe803.svg";